import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/work-schedule";

export type listType = {
  leave_status?: string;
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
  sdate?: string;
  edate?: string;
};

export class workScheduleApi extends BaseAPI {
  static getRankEmployee(query?: listType): Promise<any> {
    return this.api.get(`${path}/rank-employee`, {
      params: { ...query },
    });
  }

  static getAllTimeRecord(query?: listType): Promise<any> {
    return this.api.get(`${path}/get-all`, {
      params: { ...query },
    });
  }

  static getMyTimeRecord(query?: listType): Promise<any> {
    return this.api.get(`${path}/work-attendance-record`, {
      params: { ...query },
    });
  }

  static getTimeRecordByEmployeeId(
    emp_id: number,
    query?: listType
  ): Promise<AxiosResponse> {
    return this.api.get(`${path}/get-record-employee/${emp_id}`, {
      params: { ...query },
    });
  }

  static checkInTimeRecord(body: FormData): Promise<any> {
    return this.api.post(`${path}/check-in`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static checkOutTimeRecord(body: FormData): Promise<any> {
    return this.api.post(`${path}/check-out`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}
